<!--
  ~ Copyright (c) 2023 GM Global Technology Operations LLC. All rights reserved.
  ~ This information is confidential and proprietary to GM Global Technology
  ~ Operations LLC and may not be used, modified, copied or distributed.
  -->

<div class="filter-trigger">
  <button
    (click)="$event.stopPropagation()"
    mat-icon-button
    [matMenuTriggerFor]="menu"
    class="trigger-button"
    role="button"
    [attr.aria-label]="'number filter button ' + nextInstance"
  >
    <mat-icon class="trigger-icon" [ngClass]="{ 'filter-selected': filterIsSelected }"> filter_alt </mat-icon>
  </button>
</div>

<mat-menu #menu="matMenu" class="fab-filter-menu">
  <div (click)="$event.stopPropagation()">
    <mat-form-field appearance="outline" class="form-fields">
      <mat-select [formControl]="operator" (click)="$event.stopPropagation()">
        <mat-option *ngIf="getIndex('eq')" value="eq">Is equal to</mat-option>
        <mat-option *ngIf="getIndex('neq')" value="neq">Is not equal to</mat-option>
        <mat-option *ngIf="getIndex('gte')" value="gte">Is greater than or equal to</mat-option>
        <mat-option *ngIf="getIndex('gt')" value="gt">Is greater than</mat-option>
        <mat-option *ngIf="getIndex('lte')" value="lte">Is less than or equal to</mat-option>
        <mat-option *ngIf="getIndex('lt')" value="lt">Is less than</mat-option>
        <mat-option *ngIf="getIndex('isempty')" value="isempty">Is empty</mat-option>
        <mat-option *ngIf="getIndex('isnotempty')" value="isnotempty">Is not empty</mat-option>
      </mat-select>
    </mat-form-field>
  </div>
  <div (click)="$event.stopPropagation()" *ngIf="operator.value !== 'isempty' && operator.value !== 'isnotempty'">
    <mat-form-field appearance="outline" class="form-fields">
      <input type="number" matInput [formControl]="value" class="w-100" autocomplete="off" />
    </mat-form-field>
  </div>
  <div class="btn-row">
    <div class="filter-btn">
      <button mat-flat-button class="w-100" (click)="clearFilter()">Clear</button>
    </div>
    <div class="filter-btn">
      <button
        mat-flat-button
        color="primary"
        class="w-100"
        (click)="setFilter()"
        [disabled]="operator.value !== 'isempty' && operator.value !== 'isnotempty' && !value.value"
      >
        Filter
      </button>
    </div>
  </div>
</mat-menu>
